import React, { PureComponent, Fragment } from 'react'
import PropTypes from 'prop-types'
import { mediaQuery } from '@ycos/themes'
import { withTheme, createComponent } from '@ycos/fela'
import { getImgAttributes } from './utils'

const Image = createComponent(
  'Image',
  ({ stickyText, imageStyle }) => {
    const stickyImageStyle = {
      minWidth: '100vw',
      width: '100vw',
      height: '133.3333vw',
      maxHeight: '100vh',
      maxWidth: '177.78vh',
      margin: 'auto',
      'screen-medium': {
        height: '56.25vw'
      }
    }
    return stickyText ? { ...imageStyle, ...stickyImageStyle } : { width: '100%', height: 'auto', display: 'inherit', ...imageStyle }
  },
  'img',
  ['alt', 'data-src', 'data-src-set', 'srcSet', 'sizes', 'loading', 'data-lazy', 'fetchpriority', 'width', 'height']
)
class BasePicture extends PureComponent {
  render() {
    const { theme, desktopPicture, lazy, mobilePicture, quality, widths, nonTransformableUrls, imageStyle, stickyText, fetchPriority, extension } = this.props
    const minSizes = mediaQuery.min(theme.breakpoints)
    const desktopAttrs = getImgAttributes(desktopPicture.imageUrl, quality, widths, nonTransformableUrls, false, extension)
    const mobileAttrs = getImgAttributes(mobilePicture.imageUrl, quality, widths, nonTransformableUrls, true, extension)
    const desktopAlt = desktopPicture.alt || 'image'
    const mobileAlt = mobilePicture.alt || 'image'

    return (
      <Fragment>
        <source
          alt={desktopAlt}
          media={minSizes.medium}
          srcSet={lazy ? '' : desktopAttrs.srcSet}
          data-src-set={lazy ? desktopAttrs.srcSet : ''}
          width={desktopPicture?.width}
          height={desktopPicture?.height}
        />
        <Image
          fetchpriority={fetchPriority}
          imageStyle={imageStyle}
          stickyText={stickyText}
          alt={mobileAlt}
          data-src={lazy ? mobileAttrs.src : ''}
          data-src-set={lazy ? `${mobileAttrs.src} 2x` : ''}
          src={lazy ? '' : mobileAttrs.src}
          srcSet={lazy ? '' : `${mobileAttrs.src} 2x`}
          loading={lazy ? 'lazy' : 'eager'}
          data-lazy={lazy}
          width={mobilePicture?.width}
          height={mobilePicture?.height}
        />
      </Fragment>
    )
  }
}

BasePicture.propTypes = {
  desktopPicture: PropTypes.object.isRequired,
  mobilePicture: PropTypes.object.isRequired,
  quality: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
  fetchPriority: PropTypes.string,
  extension: PropTypes.string
}

BasePicture.defaultProps = {
  fetchPriority: null
}

BasePicture.contextTypes = {
  gridContext: PropTypes.object
}

export default withTheme(BasePicture)
